module.exports = __webpack_public_path__ + "static/img/jszc_bg.bf61423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jszc_bg.png
// module id = Dbw+
// module chunks = 1